module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-mobile-wrapper",
    class: {
      'nav-mobile-wrapper-show': _vm.isShow
    }
  }, [_c('button', {
    class: {
      'btn-mobile-show': _vm.isShow
    },
    attrs: {
      "id": "btn-mobile"
    },
    on: {
      "click": function($event) {
        return _vm.handleClick()
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "nav-mobile",
    class: {
      'nav-mobile-show': _vm.isShow
    }
  }, [(!_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToOtherRoute('0')
      }
    }
  }, [_vm._v("Login")])]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToOtherRoute('1')
      }
    }
  }, [_vm._v("Sign Up")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToOtherRoute('0')
      }
    }
  }, [_vm._v("Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToOtherRoute('2-1')
      }
    }
  }, [_vm._v("Profile")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToOtherRoute('2-3')
      }
    }
  }, [_vm._v("Logout")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14212692","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMobile.vue
// module id = 1166
// module chunks = 9